import React from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { slide as Menu } from "react-burger-menu"
import PropTypes from "prop-types"
import { document } from "browser-monads"
import LeftArrow from "./svgs/left-arrow"
import Exit from "./svgs/exit"

const MenuStyle = styled(Menu)``

const MenuWrapper = styled.div`
  position: fixed;
  z-index: 705;
  top: 0;
  width: 100%;
`

const BackButton = styled.div`
  color: ${props => props.theme.secondary800};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  width: max-content;
  min-width: 71px;
  cursor: pointer;
  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: max-content;
  }
  @media (max-width: 350px) {
    font-size: 14px;
  }
`

const Breadcrumb = styled.span`
  color: ${props => props.theme.secondary800};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  @media (max-width: 350px) {
    font-size: 14px;
  }
`

const MenuHolder = styled.div`
  max-height: calc(100vh - 144px);
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  gap: 24px;
`

const HeaderHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-shadow: 0px 2px 5px 0px rgba(214, 214, 214, 0.25);
  height: 84px;
  .exit-holder {
    min-width: 71px;
    display: flex;
    justify-content: center;
  }
`

const NavbarMenuSlider = ({
  children,
  isOpen,
  setIsOpen,
  backToindex,
  name,
}) => {
  const MobileMenuStyles = {
    bmBurgerButton: {
      display: "none",
    },
    bmCrossButton: {
      display: "none",
    },

    bmMenuWrap: {
      paddingTop: "0px",
      position: "fixed",
      height: "100%",
      width: "100%",
      maxWidth: "425px",
    },
    bmMenu: {
      background: "#fff",
      padding: "0px",
      width: "100%",
      height: "100%",
      overflow: "hidden",
    },
    bmMorphShape: {
      fill: "#373a47",
    },
    bmItemList: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      gap: "24px",
    },
    bmItem: {
      display: "flex",
    },
    bmOverlay: {
      background: "rgba(0, 0, 0, 0.3)",
    },
  }

  const sliderContent = (
    <MenuWrapper>
      <MenuStyle
        right
        styles={MobileMenuStyles}
        isOpen={isOpen}
        onClose={() => setIsOpen(backToindex)}
      >
        <HeaderHolder>
          <BackButton
            onClick={() => {
              setIsOpen(backToindex)
            }}
          >
            <div>
              <LeftArrow />
            </div>
            Back
          </BackButton>
          <Breadcrumb>{name}</Breadcrumb>
          <span
            className="exit-holder"
            style={{ cursor: "pointer" }}
            onClick={() => setIsOpen(-1)}
          >
            <Exit />
          </span>
        </HeaderHolder>
        <MenuHolder>{children}</MenuHolder>
      </MenuStyle>
    </MenuWrapper>
  )

  // Use ReactDOM.createPortal to render into the ___gatsby element
  const portalTarget =
    typeof window !== "undefined" && document.getElementById("___gatsby")
  return portalTarget
    ? ReactDOM.createPortal(sliderContent, portalTarget)
    : null
}

export default NavbarMenuSlider

NavbarMenuSlider.propTypes = {
  children: PropTypes.array,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  backToindex: PropTypes.number,
  name: PropTypes.string,
}
